module.exports = __webpack_public_path__ + "img/login-02.f3468c50.png";